import axios from 'axios';

class Mobilise {
    constructor() {
        // eslint-disable-next-line no-use-before-define
        this.client = AxiosMobilise;
    }

    getUser() {
        return this.client.get('/user');
    }

    registerUser(user) {
        return this.client.post(`/register`, user);
    }

    verifyPollToken(key, pollId) {
        return this.client.get(`/verify-key?key=${key}&poll_id=${pollId}`);
    }

    sendDailyPoll(data) {
        return this.client.post(`/customer-poll`, data);
    }

    unsubscribeDailyPoll(key) {
        return this.client.delete(`/user/unsubscribe?key=${key}`);
    }

    validateEmailAndPhoneNumber(email, phoneNumber) {
        return this.client.post(`/validateEmail`, { email, phone_number: phoneNumber });
    }
}
export default Mobilise;

const baseURL = process.env.REACT_APP_BACKEND_URL;

const AxiosMobilise = axios.create({
    baseURL,
});

AxiosMobilise.interceptors.request.use(
    (config) => {
        config.headers['Content-Type'] = 'application/json, charset=utf8';
        config.headers['Access-Control-Allow-Origin'] = baseURL;

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

AxiosMobilise.interceptors.response.use(
    async (response) => {
        return Promise.resolve(response);
    },
    async (error) => {
        if (error.response.data.errors) {
            return Promise.reject(error.response.data.errors);
        }
        return Promise.reject(error);
    },
);
